function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m66.382812 322.574219h37.933594v66.386719c0 5.234374 4.246094 9.480468 9.484375 9.480468 2.515625 0 4.925781-1 6.703125-2.777344l73.089844-73.089843h15.039062v-18.964844h-18.964843c-2.515625 0-4.929688 1-6.707031 2.777344l-59.679688 59.679687v-52.972656c0-5.238281-4.242188-9.484375-9.480469-9.484375h-47.417969c-26.175781-.03125-47.382812-21.242187-47.414062-47.417969v-189.664062c.03125-26.175782 21.242188-47.386719 47.414062-47.417969h303.46875c26.171876.03125 47.382813 21.242187 47.414063 47.417969v142.25h18.96875v-142.25c-.042969-36.644532-29.738281-66.34375-66.386719-66.382813h-303.464844c-36.644531.039063-66.3398432 29.738281-66.382812 66.382813v189.664062c.0429688 36.644532 29.738281 66.34375 66.382812 66.382813zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m502.617188 227.742188h-208.632813c-36.648437.042968-66.34375 29.738281-66.386719 66.382812v132.765625c.042969 36.648437 29.738282 66.34375 66.386719 66.386719h100.390625l73.085938 73.085937c3.707031 3.703125 9.710937 3.703125 13.414062 0 1.777344-1.777343 2.773438-4.191406 2.773438-6.703125v-66.382812h18.96875c36.644531-.042969 66.339843-29.738282 66.382812-66.386719v-132.765625c-.042969-36.644531-29.738281-66.339844-66.382812-66.382812zm47.417968 199.148437c-.03125 26.175781-21.242187 47.386719-47.417968 47.417969h-28.449219c-5.238281 0-9.484375 4.246094-9.484375 9.484375v52.972656l-59.679688-59.679687c-1.777344-1.777344-4.1875-2.777344-6.703125-2.777344h-104.316406c-26.175781-.03125-47.386719-21.242188-47.417969-47.417969v-132.765625c.03125-26.171875 21.242188-47.382812 47.417969-47.414062h208.632813c26.175781.027343 47.382812 21.242187 47.414062 47.414062v132.765625zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m75.867188 76.011719h189.667968v18.964843h-189.667968zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m303.464844 76.011719h56.902344v18.964843h-56.902344zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m75.867188 132.910156h284.5v18.964844h-284.5zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m208.632812 189.808594h151.734376v18.96875h-151.734376zm0 0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m75.867188 189.808594h94.832031v18.96875h-94.832031zm0 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m75.867188 246.710938h132.765624v18.964843h-132.765624zm0 0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m284.5 294.125h132.765625v18.96875h-132.765625zm0 0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m455.199219 294.125h56.902343v18.96875h-56.902343zm0 0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m284.5 351.027344h227.597656v18.964844h-227.597656zm0 0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m284.5 407.925781h227.597656v18.964844h-227.597656zm0 0"
});

var Svg5 = function Svg5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "569pt",
    viewBox: "0 0 569.286 569",
    width: "569pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5.b4e81beb.svg";
export { ForwardRef as ReactComponent };